import type { EventInput, EventRecord } from '../../shared/types';
import { sortEventDates } from '../../shared/dates';
import { sortWardNames } from '../../shared/wards';
import { migratePdfEventDraft } from '../../shared/pdfDrafts';
import { publishChanges } from '../../shared/publishChanges';

/** The configuration the editor works on: the saved draft, or else the event as published. */
export function eventInput(record: EventRecord): EventInput {
  const input = record.draft ?? { level: record.level, stakeName: record.stakeName, wardName: record.wardName ?? '', wardNames: record.wardNames ?? [],
    name: record.name, dates: record.dates, description: record.description, leaderName: record.leaderName,
    leaderPhone: record.leaderPhone, leaderEmail: record.leaderEmail, ...(record.adultAge ? { adultAge: record.adultAge } : {}), fields: record.fields,
    ...(record.documentForms ? {pdfFormsSchemaVersion: 2 as const,documentForms:record.documentForms}:{}) };
  return migratePdfEventDraft({ ...input, dates: sortEventDates(input.dates), wardNames: sortWardNames(input.wardNames) });
}

/** What publishing the draft would change for families, for a published or closed event; empty for one never published. */
export function unpublishedChanges(record: EventRecord, draft = record.draft): string[] {
  return record.status === 'draft' || !draft ? [] : publishChanges(eventInput({ ...record, draft: undefined }), migratePdfEventDraft(draft));
}
